<template>
  <div
      class="card d-md-block"
      style="overflow-y: hidden;margin: 8px;display: block;"
  >
    <b-card-body style="background: #fff;margin: 5px;">
      <!-- نمایش اطلاعات دستگاه -->
      <b-row v-if="deviceInfo && deviceInfo.imei">
        <b-col
            cols="6"
            style="text-align: right;"
        >
          {{ deviceInfo.title }}
        </b-col>
        <b-col
            cols="6"
            style="text-align: left;"
        >
          {{ deviceInfo.imei }}
        </b-col>
      </b-row>

      <!-- پیام لودینگ -->
      <b-row v-else>
        <b-col
            cols="12"
            style="text-align: center; padding: 20px;"
        >
          <p>در حال بارگذاری اطلاعات دستگاه...</p>
        </b-col>
      </b-row>

      <v-tabs
          vertical
          class="commandTabs"
      >
        <!-- Tab Headers -->
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-car-brake-alert
          </v-icon>
          شماره اضطراری
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-vibrate
          </v-icon>
          هشدار لرزشی
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-account-tie
          </v-icon>
          شماره مدیر
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-power-plug-off
          </v-icon>
          قطع برق
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-power-plug
          </v-icon>
          وصل برق
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-power
          </v-icon>
          هشدار قطع برق
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-battery-alert-variant-outline
          </v-icon>
          هشدار باطری
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-car-electric
          </v-icon>
          هشدار سوئیچ
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-car-emergency
          </v-icon>
          هشدار جابجایی
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-car-speed-limiter
          </v-icon>
          هشدار سرعت
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-server-network
          </v-icon>
          تنظیم سرور
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-restart
          </v-icon>
          راه اندازی مجدد
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-console-line
          </v-icon>
          {{ $t('Custom Command') }}
        </v-tab>
        <v-tab>
          <v-icon
              size="18"
              left
          >
            mdi-history
          </v-icon>
          تاریخچه درخواست‌ها
        </v-tab>

        <!-- Tab Contents -->
        <!-- Emergency Numbers Tab -->
        <v-tab-item>
          <EmergencyNumberSettings
              v-if="deviceInfo && deviceInfo.imei && selectedImei"
              :selected-imei="selectedImei"
              :device-info="deviceInfo"
              @command-sent="onCommandSent"
          />
          <div
              v-else
              class="loading-container"
              style="text-align: center; padding: 40px;"
          >
            <p style="margin-top: 16px;">
              در حال بارگذاری اطلاعات دستگاه...
            </p>
            <p style="font-size: 12px; color: #666;">
              IMEI: {{ selectedImei || 'در حال شناسایی...' }}
            </p>
          </div>
        </v-tab-item>

        <!-- Vibration Alert Tab -->
        <v-tab-item>
          <VibrationAlertSettings
              v-if="deviceInfo && deviceInfo.imei && selectedImei"
              :selected-imei="selectedImei"
              :device-info="deviceInfo"
              @command-sent="onCommandSent"
          />
          <div
              v-else
              class="loading-container"
              style="text-align: center; padding: 40px;"
          >
            <p style="margin-top: 16px;">
              در حال بارگذاری اطلاعات دستگاه...
            </p>
          </div>
        </v-tab-item>

        <!-- Center Number Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-radio-group
                  v-model="adminval"
                  row
              >
                <v-radio
                    label="تنظیمات"
                    value="adminSet"
                />
                <v-radio
                    label="حذف شماره مدیر"
                    value="adminDel"
                />
              </v-radio-group>
              <div v-if="adminval==='adminSet'">
                <p>این شماره قابلیت خاموش و روشن کردن خودرو را دارد.<br>
                  این دستور حتما توسط یکی از شماره های اضطراری باید ارسال شود.</p>
                <b-form-group
                    label="شماره همراه"
                    label-for="v-phone"
                >
                  <b-form-input
                      v-model="phone"
                      style="text-align: left;"
                  />
                </b-form-group>
                <b-button
                    size="sm"
                    variant="success"
                    @click="onSendCommand(selectedImei, 'CENTER,A,'+phone+'#')"
                >
                  ارسال پیامک
                </b-button>
              </div>
              <div v-else>
                <b-button
                    size="sm"
                    variant="success"
                    @click="onSendCommand(selectedImei, 'CENTER,D#')"
                >
                  ارسال پیامک
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Power Off Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <p>پس از ارسال این دستور، تنها در صورتی که سرعت خودرو کمتر از 20 کیلومتر در ساعت باشد برق خودرو قطع می شود.</p>
                <b-button
                    style="background: #c72828 !important;border-radius: 10px;border: 1px solid #fff !important;"
                    class="btn btn-light btn-sm"
                    :disabled="powerBtnDisabled(selectedImei, 'powerOff')"
                    @click="onSendCommand(selectedImei, 'powerOff')"
                >
                  <v-icon
                      size="20"
                      color="#fff"
                  >mdi-power-plug-off</v-icon>
                  <span style="">قطع برق</span>
                </b-button>
                <power-command-status
                  :imei="selectedImei"
                  :state="powerCmd"
                  :relay="relayInfo(selectedImei)"
                  :elapsed="powerCmdElapsed()"
                  class="mt-1"
                  @dismiss="dismissPowerCmd"
                />
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Power On Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <p>در صورتی که برق خودرو را قطع کرده باشید با این دستور می توانید برق را دوباره وصل کنید.</p>
                <b-button
                    style="background: #28c76a !important;border-radius: 10px;border: 1px solid #fff !important;"
                    class="btn btn-light btn-sm"
                    :disabled="powerBtnDisabled(selectedImei, 'powerOn')"
                    @click="onSendCommand(selectedImei, 'powerOn')"
                >
                  <v-icon
                      size="20"
                      color="#fff"
                  >mdi-power-plug</v-icon>
                  <span style="">وصل برق</span>
                </b-button>
                <power-command-status
                  :imei="selectedImei"
                  :state="powerCmd"
                  :relay="relayInfo(selectedImei)"
                  :elapsed="powerCmdElapsed()"
                  class="mt-1"
                  @dismiss="dismissPowerCmd"
                />
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Power Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <v-select
                    v-model="MODE_POWERALM"
                    :items="itemsSENALM"
                    item-text="name"
                    item-value="value"
                    :label="$t('Send alerts via')"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                    variant="gradient-warning"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'POWERALM,ON,'+MODE_POWERALM+',5,300#')"
                >
                  <span style="">روشن کردن هشدار قطع برق</span>
                </b-button>
                <br><br>
                <b-button
                    variant="gradient-primary"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'POWERALM,OFF#')"
                >
                  <span style="">خاموش کردن هشدار قطع برق</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Battery Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <v-select
                    v-model="MODE_ALM"
                    :items="itemsSENALM"
                    item-text="name"
                    item-value="value"
                    :label="$t('Send alerts via')"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                    variant="gradient-warning"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'BATALM,ON,' + MODE_ALM + '#')"
                >
                  <span style="">روشن کردن هشدار باطری</span>
                </b-button>
                <br><br>
                <b-button
                    variant="gradient-primary"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'BATALM,OFF#')"
                >
                  <span style="">خاموش کردن هشدار باطری</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Switch Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <v-select
                    v-model="MODE_ACCALM"
                    :items="itemsSENALM"
                    item-text="name"
                    item-value="value"
                    :label="$t('Send alerts via')"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                    variant="gradient-warning"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'ACCALM,ON,'+MODE_ACCALM+',10,0#')"
                >
                  <span style="">روشن کردن هشدار سوئیچ</span>
                </b-button>
                <br><br>
                <b-button
                    variant="gradient-primary"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'ACCALM,OFF#')"
                >
                  <span style="">خاموش کردن هشدار سوئیچ</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Movement Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <b-form-group
                    label="شعاع حرکت (متر)"
                >
                  <b-form-input
                      v-model="limitmetr"
                      style="text-align: left;"
                  />
                </b-form-group>
                <v-select
                    v-model="MODE_MOVING"
                    :items="itemsNOtF"
                    item-text="name"
                    item-value="value"
                    :label="$t('Send alerts via')"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                    variant="gradient-warning"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'MOVING,ON,'+limitmetr+','+MODE_MOVING+'#')"
                >
                  <span style="">روشن کردن هشدار جابجایی</span>
                </b-button>
                <br><br>
                <b-button
                    variant="gradient-primary"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'MOVING,OFF#')"
                >
                  <span style="">خاموش کردن هشدار جابجایی</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Speed Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <b-form-group
                    label="حداکثر سرعت مجاز"
                >
                  <b-form-input
                      v-model="limitspeed"
                      style="text-align: left;"
                  />
                </b-form-group>
                <b-form-group
                    label="فاصله زمانی هشدار (برحسب ثانیه)"
                >
                  <b-form-input
                      v-model="limitspeedtime"
                      style="text-align: left;"
                  />
                </b-form-group>
                <v-select
                    v-model="MODE_speed"
                    :items="itemsNOtF"
                    item-text="name"
                    item-value="value"
                    :label="$t('Send alerts via')"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                    variant="gradient-warning"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'SPEED,ON,'+limitspeedtime+','+limitspeed+','+MODE_speed+'#')"
                >
                  <span style="">روشن کردن هشدار سرعت</span>
                </b-button>
                <br><br>
                <b-button
                    variant="gradient-primary"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'SPEED,OFF#')"
                >
                  <span style="">خاموش کردن هشدار سرعت</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Server Settings Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <b-button
                    variant="gradient-info"
                    class="btn-sm"
                    @click="SendSms('SERVER,1,s1.payandservice.ir,4000,0#')"
                >
                  <span style="">ارسال تنظیات سرور</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Restart Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <b-button
                    variant="gradient-info"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, 'RESET#')"
                >
                  <span style="">راه اندازی مجدد دستگاه</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Custom Command Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <p>{{ $t('Text-15') }}</p>
              <b-form-group>
                <b-form-input
                    v-model="textCustom"
                    style="text-align: left;"
                />
              </b-form-group>
              <div style="text-align: center;">
                <b-button
                    variant="gradient-info"
                    class="btn-sm"
                    @click="onSendCommand(selectedImei, textCustom)"
                >
                  <span style="">{{ $t('Send') }}</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Command History Tab -->
        <v-tab-item>
          <CommandHistory
              v-if="deviceInfo && deviceInfo.imei && selectedImei"
              :selected-imei="selectedImei"
              :device-info="deviceInfo"
          />
          <div
              v-else
              class="loading-container"
              style="text-align: center; padding: 40px;"
          >
            <p style="margin-top: 16px;">
              در حال بارگذاری تاریخچه...
            </p>
          </div>
        </v-tab-item>

      </v-tabs>
    </b-card-body>
  </div>
</template>

<script>
import {
  BLink, BButton, BCard, BCardText, BCardBody, BRow, BCol, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { getUserData } from '@/auth/utils'
import EmergencyNumberSettings from '@/views/Home/EmergencyNumberSettings.vue'
import VibrationAlertSettings from '@/views/Home/VibrationAlertSettings.vue'
import CommandHistory from '@/views/Home/CommandHistory.vue'

import deviceCommand from '@/mixins/deviceCommand'
import PowerCommandStatus from '@/components/device-command/PowerCommandStatus.vue'

export default {
  components: {
    PowerCommandStatus,
    EmergencyNumberSettings,
    VibrationAlertSettings,
    CommandHistory,
    BLink,
    BButton,
    BCard,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
  },
  mixins: [deviceCommand],
  data() {
    return {
      address: '',
      sortBy: 'creationTime',
      selectedImei: null,
      deviceInfo: null,
      imei: getUserData().imei,
      phone: '',
      phone2: '',
      phone3: '',
      phone4: '',
      textCustom: '',
      sosval: 'sosSet',
      adminval: 'adminSet',
      limitspeed: 100,
      limitspeedtime: 20,
      limitmetr: 100,
      itemslevel: ['1', '2', '3', '4', '5'],
      selectlevel: '1',
      itemsNOtF: [{ name: 'اپلیکشن', value: '0' }, { name: 'پیامک و اپلیکیشن', value: '1' }],
      MODE_ALM: '1',
      itemsSENALM: [{ name: 'اپلیکشن', value: '0' }, { name: 'پیامک و اپلیکیشن', value: '1' }, { name: 'پیامک و اپلیکیشن و تماس', value: '2' }],
      MODE_SENALM: '1',
      MODE_speed: '1',
      MODE_MOVING: '1',
      MODE_POWERALM: '1',
      MODE_ACCALM: '1',
    }
  },
  computed: {
    computedSelectedImei() {
      return this.selectedImei
          || Vue.prototype.$selectCommand
          || this.$route.params.imei
          || null
    },
  },
  watch: {
    computedSelectedImei: {
      handler(newImei) {
        if (newImei && newImei !== this.selectedImei) {
          // console.log('🔄 IMEI تغییر کرد:', newImei)
          this.selectedImei = newImei
          this.loadDeviceInfo()
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    // console.log('📱 Command component mounted')
    await this.initializeComponent()
  },
  methods: {
    async initializeComponent() {
      // console.log('🔄 شروع مقداردهی اولیه...')

      const possibleImeis = [
        Vue.prototype.$selectCommand,
        this.$route.params.imei,
        this.selectedImei,
      ].filter(Boolean)

      // console.log('📋 IMEI های احتمالی:', possibleImeis)

      if (possibleImeis.length > 0) {
        this.selectedImei = possibleImeis[0]
        await this.loadDeviceInfo()
      } else {
        // console.log('⏳ IMEI پیدا نشد، در حال تلاش مجدد...')
        await this.retryFindImei()
      }
    },

    async retryFindImei() {
      for (let i = 0; i < 5; i++) {
        await new Promise(resolve => setTimeout(resolve, 500))

        const imei = Vue.prototype.$selectCommand || this.$route.params.imei
        if (imei) {
          // console.log(`✅ IMEI پیدا شد در تلاش ${i + 1}:`, imei)
          this.selectedImei = imei
          await this.loadDeviceInfo()
          return
        }

        // console.log(`⏳ تلاش ${i + 1}/5 برای پیدا کردن IMEI...`)
      }

      // console.error('❌ پس از 5 تلاش، IMEI پیدا نشد')
    },

    async loadDeviceInfo() {
      if (!this.selectedImei) {
        // console.warn('⚠️ selectedImei موجود نیست')
        return
      }

      // console.log('📋 در حال لود اطلاعات دستگاه برای IMEI:', this.selectedImei)

      try {
        if (!Vue.prototype.$functions) {
          // console.error('❌ Vue.prototype.$functions موجود نیست')
          return
        }

        const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.selectedImei)

        if (!deviceInfo) {
          // console.warn('⚠️ اطلاعات دستگاه پیدا نشد برای IMEI:', this.selectedImei)
          setTimeout(() => {
            this.loadDeviceInfo()
          }, 1000)
          return
        }

        // console.log('✅ اطلاعات دستگاه لود شد:', deviceInfo)

        Vue.prototype.$functions.setMobileSelectedDevices([this.selectedImei])
        this.deviceInfo = deviceInfo

        if (this.deviceInfo?.userId?.mobile) {
          this.phone = this.deviceInfo.userId.mobile
        }

        await this.loadAddress()
      } catch (error) {
        // console.error('❌ خطا در لود اطلاعات دستگاه:', error)
      }
    },

    async loadAddress() {
      try {
        if (this.deviceInfo?.serverInfo) {
          const coords = Vue.prototype.$functions.getLatLngFromServerInfo(this.deviceInfo.serverInfo)
          if (coords) {
            this.address = await Vue.prototype.$functions.getFullAddress({
              latitude: coords.lat,
              longitude: coords.lng,
            }, this.selectedImei || this.imei)
          }
        }
      } catch (error) {
        // console.error('❌ خطا در لود آدرس:', error)
      }
    },

    onCommandSent(data) {
      // console.log('📤 دستور ارسال شد:', data)

      // اگر دستور موفق بود، می‌توانیم اطلاعات دستگاه را دوباره لود کنیم
      if (data.success) {
        // Optional: reload device info if needed
        // setTimeout(() => this.loadDeviceInfo(), 1000)
      }
    },

    SendSms(txt) {
      if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = `sms://${this.deviceInfo.sim}&body=${encodeURIComponent(txt)}`
      } else if (Vue.prototype.$productionPlatform === 'android') {
        window.location.href = `sms:${this.deviceInfo.sim}?body=${encodeURIComponent(txt)}`
      } else {
        window.location.href = `sms:${this.deviceInfo.sim}?body=${encodeURIComponent(txt)}`
      }
    },

    async loadDetail() {
      await this.loadDeviceInfo()
    },

    onSendCommand(imei, commandName) {
      // Validation
      if (!imei) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا',
            text: 'IMEI دستگاه یافت نشد',
            icon: 'XIcon',
            variant: 'danger',
          },
        })
        return
      }

      if (!commandName || commandName.trim() === '') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا',
            text: 'دستور نمی‌تواند خالی باشد',
            icon: 'XIcon',
            variant: 'danger',
          },
        })
        return
      }

      // ارسال و نشان دادنِ نتیجهٔ واقعیِ دستگاه (mixins/deviceCommand)
      this.sendDeviceCommand(imei, commandName)
    },
  },
}
</script>

<style scoped>
.commandTabs {
  margin-top: 16px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 16px;
}

.v-tab {
  justify-content: flex-start !important;
  text-align: right;
}

.v-tab .v-icon {
  margin-left: 8px;
  margin-right: 0;
}

/* RTL Support */
[dir="rtl"] .v-tab .v-icon {
  margin-left: 0;
  margin-right: 8px;
}

/* Custom button styles */
.btn-sm {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  border-radius: 0.375rem;
  margin: 0.25rem;
}

/* Form input styles */
.b-form-input {
  border-radius: 0.375rem;
  border: 1px solid #d1d5db;
}

.b-form-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Card styles */
.v-card--flat {
  box-shadow: none !important;
}

.v-card-text {
  padding: 24px;
}

/* Select styles */
.v-select {
  margin-bottom: 16px;
}

/* Responsive design */
@media (max-width: 768px) {
  .commandTabs {
    flex-direction: column;
  }

  .v-tabs--vertical {
    flex-direction: column;
  }

  .v-tab {
    width: 100%;
    min-height: 48px;
  }
}

/* Loading animation */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.loading-container p {
  animation: pulse 2s infinite;
}

/* Hover effects */
.btn:hover {
  transform: translateY(-1px);
  transition: all 0.2s ease;
}

.btn:active {
  transform: translateY(0);
}

/* Error states */
.has-error .b-form-input {
  border-color: #dc3545;
}

.has-error .b-form-input:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

/* Success states */
.has-success .b-form-input {
  border-color: #28a745;
}

.has-success .b-form-input:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
}
</style>

